import React from "react";
import { Button } from "./button";
import { Typography } from "./typography";
import { Card, CardContent } from "./card";
import Header from "../../layouts/Header";
import classNames from "classnames";
import purchaseIcon from "../../assets/images/purchase.png";
import stackFailureIcon from "../../assets/images/autostack/error-check-circle.svg";

interface StatusConfig {
  title: string;
  description: string | React.ReactNode;
  buttonText: string;
}

interface StatusStepProps {
  isSuccess: boolean;
  onContinue: () => void;
  successConfig: StatusConfig;
  failureConfig: StatusConfig;
  hideCard?: boolean;
}

const StatusStep: React.FC<StatusStepProps> = ({
  isSuccess,
  onContinue,
  successConfig,
  failureConfig,
  hideCard = false,
}) => {
  const config = isSuccess ? successConfig : failureConfig;
  const image = isSuccess ? purchaseIcon : stackFailureIcon;

  const StatusContent = () => (
    <div className="flex flex-col items-center text-center space-y-4">
      {isSuccess && (
        <img
          src={image}
          alt="Success"
          width={194}
          height={136}
          className="mb-6"
        />
      )}
      {!isSuccess && <img src={image} alt="Error" className="mb-6" />}

      <Typography
        variant="h2"
        className="mb-4 text-center max-w-[483px] text-[32px] font-bold text-[#33125F]"
      >
        {config.title}
      </Typography>

      <Typography
        variant="p"
        className={`text-[#423E51] ${isSuccess ? "max-w-[358px]" : "max-w-[683px]"} mb-6 text-lg font-normal`}
      >
        {config.description}
      </Typography>

      <div className="pt-4 w-full max-w-md">
        <Button
          onClick={onContinue}
          className={classNames(
            "bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)]  text-white hover:opacity-90 w-full py-3 h-[48px] rounded-full font-bold",
            isSuccess ? " max-w-[302px]" : " max-w-[176px] mt-10"
          )}
          aria-label={config.buttonText}
        >
          {config.buttonText}
        </Button>
      </div>
    </div>
  );

  if (hideCard) {
    return <StatusContent />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex items-center justify-center min-h-[calc(100vh-64px)] px-4 py-8">
        <Card className="w-full max-w-2xl border-gray-100 rounded-3xl overflow-hidden">
          <CardContent className="px-6 py-12">
            <StatusContent />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StatusStep;
